<template>
  <div>
    <ListWrapper
      ref="listWrapper"
      :url="url"
      :extraButtons="extraButtons"
      :hasAddButton="isCenterExecutePage && checkSharedAccesses('ADD')"
      :addButtonText="$lang.newCenterExecute"
      :emptyImage="generateEmptyImage"
      :emptyText="generateEmptyText"
      @getPermissions="getPermissions"
      @getFilters="getFilters"
      @handleAddButton="handleOpenAddCenterExecutePin"
    >
      <template slot-scope="{ items }">
        <CardList
          :items="items"
          loadingComponent="CenterExecute"
          :showBody="showBody"
          accordion=""
        >
          <template slot="header" slot-scope="{ item }">
            <b-row class="margin-0 width-percent-100">
              <b-col
                v-if="isEndedCenterExecutePage"
                cols="12"
                lg="auto"
                class="p-0 mobile-none tablet-none"
                @click.stop="() => {}"
              >
                <b-form-checkbox
                  class="margin-left-8"
                  size="lg"
                  @change="handleChangeSelectedItems(item.code)"
                />
              </b-col>
              <b-col
                cols="12"
                lg="5"
                class="flex-start flex-direction-column padding-0"
              >
                <HeaderRowRightItems
                  mode="MOBILE"
                  :item="item"
                  :menuPopupItems="generateItemButtons(item)"
                  :permissions="permissions"
                  :casesLink="generateCenterExecuteCasesRouteLink(item)"
                  @handleReloadList="listWrapperReload"
                />
                <div class="flex-start width-percent-100">
                  <div v-if="isEndedCenterExecutePage" @click.stop="() => {}">
                    <Checkbox
                      :value="item"
                      name="startAtTime"
                      hoverClass=""
                      rowClass="padding-0 padding-left-2 margin-bottom-0 flex-center height-percent-100 desktop-none"
                    />
                  </div>
                  <span
                    class="padding-left-4 color-complementary-400 text-ellipsis"
                    v-b-tooltip.hover
                    :title="pathOr('', ['caption'], item)"
                  >
                    {{ pathOr("", ["caption"], item) }}
                  </span>
                  <span class="color-complementary-100 margin-x-4">|</span>
                  <span class="color-complementary-200">
                    {{ pathOr("", ["id"], item) }}
                  </span>
                </div>
                <div
                  class="font-size-12 color-complementary-300 width-percent-100"
                >
                  {{ pathOr("", ["term", "title"], item) }}
                </div>
              </b-col>
              <b-col
                cols="12"
                lg="3"
                class="font-size-12 color-complementary-300 padding-0 padding-x-12 mobile-padding-x-0 tablet-padding-x-0"
              >
                <div>
                  <span>{{ $lang.runType }}:</span>
                  <span>
                    {{ pathOr("", ["center_execute_type", "title"], item) }}
                  </span>
                </div>
                <div>
                  <span>{{ $lang.startDate }}:</span>
                  <span>
                    {{ pathOr("", ["start_date", "jalali"], item) }}
                  </span>
                  <span v-if="pathOr(false, ['start_delay'], item)">
                    <span class="color-complementary-100"> | </span>
                    <span>{{ $lang.delayTime }}:</span>
                    <span>
                      {{ pathOr("", ["start_delay"], item) }} {{ $lang.minute }}
                    </span>
                  </span>
                </div>
              </b-col>
              <b-col
                cols="12"
                lg=""
                class="position-relative mobile-none tablet-none flex-end padding-0"
              >
                <HeaderRowRightItems
                  mode="DESKTOP"
                  :item="item"
                  :menuPopupItems="generateItemButtons(item)"
                  :permissions="permissions"
                  :casesLink="generateCenterExecuteCasesRouteLink(item)"
                  @handleReloadList="listWrapperReload"
                />
              </b-col>
            </b-row>
          </template>
          <template slot="card-body" slot-scope="{ item }">
            <b-row class="m-0" v-if="item">
              <b-col cols="12" class="padding-0 margin-bottom-8">
                <span>{{ $lang.company }}: {{ item.companyName }}</span>
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8 flex-start">
                <span class="direction__ltr">
                  {{ $lang.assessmentPlan }}: {{ item.assessmentPlan.name }}
                </span>
                <span class="color-complementary-100 margin-x-4"> | </span>
                <span>{{ item.assessmentPlan.id }}</span>
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8 flex-start">
                <span class="direction__ltr">
                  {{ $lang.template }}: {{ item.template.name }}
                </span>
                <span class="color-complementary-100 margin-x-4"> | </span>
                <span>{{ item.template.id }}</span>
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8">
                <span class="margin-left-16">
                  {{ $lang.candidateCount }}: {{ $lang.modified }}:
                  {{ item.candidate.total }}
                  <span class="color-complementary-100"> | </span>
                  {{ $lang.absent }}: {{ item.candidate.absent }}
                  <span class="color-complementary-100"> | </span>
                  {{ $lang.parvandehAssignment }}:
                  {{ item.candidate.hasParvandehCount }}
                </span>
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8">
                <span class="margin-left-16">
                  {{ $lang.modifiedAssessmentCount }}: {{ item.assessor.total }}
                  <span class="color-complementary-100"> | </span>
                  {{ $lang.absent }}: {{ item.assessor.absent }}
                  <span class="color-complementary-100"> | </span>
                  {{ $lang.parvandehAssignment }}:
                  {{ item.assessor.hasParvandehCount }}
                </span>
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8">
                <span class="margin-left-16">
                  {{ $lang.caseCount }}: {{ $lang.all }}:
                  {{ item.centerExecuteCase.total }}
                  <span class="color-complementary-100"> | </span>
                  {{ $lang.notSended }}:
                  {{ item.centerExecuteCase.notStartCount }}
                </span>
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8">
                <span class="margin-left-16">
                  {{ $lang.roomCount }}: {{ item.roomCount }}
                </span>
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8">
                <span class="margin-left-16">
                  {{ $lang.showUserInformation }}:
                  {{ item.personShowCompleteData }}
                </span>
              </b-col>
              <b-col cols="12" class="padding-0 margin-bottom-8">
                <span class="margin-left-16">
                  {{ $lang.createdBy }}: {{ item.createdBy }}
                </span>
                <span>
                  {{ $lang.createdAt }}:
                  <span v-html="item.createdAt" />
                </span>
              </b-col>
            </b-row>
          </template>
        </CardList>
      </template>
    </ListWrapper>
    <AddCenterExecutePin
      :visible="isAddCenterExecutePin"
      :permissions="permissions"
      @handleClose="handleCloseAddCenterExecutePin"
      @handleReloadList="listWrapperReload"
    />
    <ExecutePlanListPin
      :visible="isExecutePlanPin"
      :id="centerExecuteId"
      @handleClose="handleCloseExecutePlanListPin"
    />
    <Modal
      :show="isStartDelayModal"
      :title="$lang.submitDelayTime"
      :closeOnBackdrop="false"
      :hasClose="false"
      :hasFooter="false"
      size="sm"
      @close="handleCloseStartDelayModal"
    >
      <template #body>
        <ChangeStartDelay
          :item="currentItem"
          @handleClose="handleCloseStartDelayModal"
          @reloadList="listWrapperReload"
        />
      </template>
    </Modal>
    <Modal
      :show="isChangeAssessmentPlanModal"
      :title="$lang.changeAssessmentPlan"
      :closeOnBackdrop="false"
      :hasClose="false"
      :hasFooter="false"
      size="sm"
      @close="handleCloseChangeAssessmentPlanModal"
    >
      <template #body>
        <ChangeAssessmentPlan
          :item="currentItem"
          @handleClose="handleCloseChangeAssessmentPlanModal"
          @reloadList="listWrapperReload"
        />
      </template>
    </Modal>
    <Modal
      :show="isRemoveCenterExecuteModal"
      :title="$lang.removeCenterExecute"
      :closeOnBackdrop="false"
      :hasClose="false"
      :okButton="true"
      :okButtonText="$lang.remove"
      okButtonVariant="filled-error"
      size="sm"
      :ok="removeCenterExecuteItem"
      @close="handleCloseRemoveCenterExecuteModal"
    >
      <template #body>
        <div class="margin-bottom-24 font-size-14 color-complementary-300">
          {{ $lang.centerExecuteDeleteAlert }}
        </div>
      </template>
    </Modal>
    <Modal
      :show="isDuplicateCenterExecuteModal"
      :title="$lang.duplicateCenterExecute"
      :closeOnBackdrop="false"
      :hasClose="false"
      :okButton="true"
      :okButtonText="$lang.duplicate"
      okButtonVariant="filled-primary"
      size="sm"
      :ok="duplicateCenterExecuteItem"
      @close="handleCloseDuplicateCenterExecuteModal"
    >
      <template #body>
        <div class="margin-bottom-24 font-size-14 color-complementary-300">
          {{ $lang.centerExecuteDuplicateAlert }}
        </div>
      </template>
    </Modal>
    <Modal
      :show="isAddPersonByExcelModal"
      :title="$lang.uploadPersonCenterExecute"
      :closeOnBackdrop="false"
      :hasClose="false"
      :hasFooter="false"
      size="sm"
    >
      <template #body>
        <ResourceUploader
          :url="addPersonByExcelResourceUploadUrl"
          :label="$lang.attachFile"
          :hasEditTitle="true"
          :cancelButton="true"
          exampleFileName="import_center_execute_person"
          uploaderName="center_execute_person_import"
          @onSuccessUpload="handleCloseAddPersonByExcelModal"
          @close="handleCloseAddPersonByExcelModal"
        />
      </template>
    </Modal>
    <Modal
      :show="isChangeGroupStatusModal"
      :title="$lang.changeGroupStatusCenterExecutes"
      :closeOnBackdrop="false"
      :hasClose="false"
      :hasFooter="true"
      :okButton="true"
      :ok="handleSubmitChangeGroupStatus"
      size="sm"
      @close="handleCloseChangeGroupStatusModal"
    >
      <template #body>
        <Alert class="margin-bottom-16" :text="$lang.changeToStatusMessage" />
        <EnumDropdown
          :title="$lang.changeToStatus"
          :label="$lang.changeToStatus"
          :placeholder="$lang.changeToStatus"
          :value="form.centerExecuteStatus"
          name="centerExecuteStatus"
          id="centerExecuteStatus"
          categoryName="center_execute_status"
          :vuelidateObj="$v.form.centerExecuteStatus"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
      </template>
    </Modal>
    <Modal
      :show="isIncompleteCompletion"
      :title="$lang.incompleteCompletion"
      :closeOnBackdrop="false"
      :hasClose="true"
      :hasFooter="true"
      size="sm"
      :okButton="true"
      okButtonVariant="filled-error"
      :okButtonText="$lang.incompleteCompletion"
      :ok="handleSubmitIncompleteCompletionModal"
      @close="handleCloseIncompleteCompletionModal"
    >
      <template #body>
        <div class="margin-bottom-24 font-size-14 color-complementary-300">
          {{ $lang.incompleteCompletionSureCaptionMessage }}
          <br />{{ $lang.incompleteCompletionSureMessage }}
        </div>
      </template>
    </Modal>
    <Modal
      :show="isScoreExcelExportModal"
      :title="$lang.center_execute_score_excel"
      :closeOnBackdrop="false"
      :hasClose="true"
      :hasFooter="true"
      size="sm"
      :okButton="true"
      okButtonVariant="filled-primary"
      :okButtonText="$lang.getExport"
      :ok="handleScoreExcelExport"
      @close="handleCloseScoreExcelModal"
    >
      <template #body>
        <div
          class="margin-bottom-24 font-size-14 color-complementary-300 text-justify"
        >
          <span v-html="$lang.are_you_sure_center_execute_score_excel" />
        </div>
      </template>
    </Modal>
    <Modal
      :show="isRebuildAllReportsModal"
      :title="$lang.kanoon_rebuild_all_reports"
      :closeOnBackdrop="false"
      :hasClose="true"
      :hasFooter="true"
      size="sm"
      :okButton="true"
      okButtonVariant="filled-primary"
      :okButtonText="$lang.rebuild"
      :ok="handleRebuildAllReports"
      @close="handleCloseRebuildAllReportsModal"
    >
      <template #body>
        <div
          class="margin-bottom-24 font-size-14 color-complementary-300 text-justify"
        >
          <span v-html="$lang.are_you_sure_kanoon_rebuild_all_reports" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import inputMixin from "@/mixin/inputMixin.vue";
import {
  ListWrapper,
  CardList,
  Modal,
  ResourceUploader,
  Alert,
} from "@/components/re-design";
import { Checkbox, EnumDropdown } from "@/components/re-design/forms";
import AddCenterExecutePin from "./components/AddCenterExecutePin.vue";
import ExecutePlanListPin from "./components/assessment-plan-list-pin/ExecutePlanListPin.vue";
import ChangeStartDelay from "./components/ChangeStartDelay.vue";
import ChangeAssessmentPlan from "./components/ChangeAssessmentPlan.vue";
import HeaderRowRightItems from "./components/HeaderRowRightItems.vue";
import { required } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import {
  generateApiUrl,
  generateError,
  goToRoute,
  toastAlert,
  checkPermission,
  storeDispatcher,
  generateRouteLink,
  generateCurrentRoute,
  generateQueryStringWithKeysRepeat,
} from "@/shared/utils";
import { mapActions } from "vuex";
import {
  getCenterExecute,
  deleteCenterExecute,
  setCenterExecuteExport,
  setChangeGroupStatus,
  setIncompleteCompletion,
  duplicateCenterExecute,
  rebuildAllReports,
  getCenterExecuteScoreExcel,
  getAllCenterExecutePerson,
} from "@/modules/kanoon/services";

export default {
  mixins: [inputMixin],
  components: {
    ListWrapper,
    CardList,
    Modal,
    ResourceUploader,
    Alert,
    EnumDropdown,
    AddCenterExecutePin,
    ExecutePlanListPin,
    ChangeStartDelay,
    ChangeAssessmentPlan,
    HeaderRowRightItems,
    Checkbox,
  },
  provide() {
    // generate provide data
    return {
      goToCenterExecuteEdit: this.goToCenterExecuteEdit,
      checkSharedAccesses: this.checkSharedAccesses,
    };
  },
  validations() {
    return {
      form: {
        centerExecuteStatus: { required },
      },
    };
  },
  data() {
    return {
      form: { centerExecuteStatus: null },
      permissions: [],
      listFilters: null,
      itemMenuId: 0,
      currentItem: null,
      centerExecuteId: null,
      centerExecuteCaption: null,
      isExecutePlanPin: false,
      isStartDelayModal: false,
      isChangeAssessmentPlanModal: false,
      isRemoveCenterExecuteModal: false,
      isDuplicateCenterExecuteModal: false,
      isAddCenterExecutePin: false,
      isAddPersonByExcelModal: false,
      isChangeGroupStatusModal: false,
      isIncompleteCompletion: false,
      selectedItems: [],
      isScoreExcelExportModal: false,
      isRebuildAllReportsModal: false,
      goToDashboardLoading: false,
      exportExcelLoading: false,
    };
  },
  computed: {
    url() {
      const routeName = generateCurrentRoute();
      const isEndedCenterExecutePage = routeName === "ended_center_execute";
      const isMyCenterExecutePage = routeName === "my_center_execute";
      const isCenterExecutePlannerPage = routeName === "center-execute-planner";

      if (isCenterExecutePlannerPage) {
        return generateApiUrl(["kanoon", "centerExecuteWithAccess"]);
      } else if (isEndedCenterExecutePage) {
        return generateApiUrl(["kanoon", "endedCenterExecutes"]);
      } else if (isMyCenterExecutePage) {
        return generateApiUrl(["kanoon", "myCenterExecutes"]);
      }
      return generateApiUrl(["kanoon", "v2", "centerExecutes"]);
    },
    extraButtons() {
      return [
        {
          caption: this.$lang.uploadPersonCenterExecute,
          icon: "tray-arrow-up",
          show:
            this.isCenterExecutePage &&
            this.checkSharedAccesses("ADD-PERSON-CENTER-EXECUTE-BY-EXCEL"),
          permissions: ["admin", "edit"],
          loading: false,
          click: this.handleOpenAddPersonByExcelModal,
        },
        {
          caption: this.$lang.changeGroupStatusCenterExecutes,
          icon: "state-machine",
          show: !this.isEndedCenterExecutePage,
          permissions: ["admin"],
          loading: false,
          click: this.handleOpenChangeGroupStatusModal,
        },
        {
          caption: this.$lang.center_execute_score_excel,
          icon: "shield-check-outline",
          show: this.isEndedCenterExecutePage && this.selectedItems.length > 0,
          permissions: ["admin"],
          loading: false,
          click: this.handleOpenScoreExcelExportModal,
        },
        {
          caption: this.$lang.kanoon_rebuild_all_reports,
          icon: "file-sync-outline",
          show: this.isEndedCenterExecutePage,
          permissions: ["admin"],
          loading: false,
          click: this.handleOpenRebuildAllReportsModal,
        },
      ];
    },
    generateEmptyImage() {
      return this.$config.images.shared.redesign.empty.list;
    },
    generateEmptyText() {
      return this.$lang.list_empty_text;
    },
    addPersonByExcelResourceUploadUrl() {
      return generateApiUrl(["kanoon", "importCenterExecutePerson"]);
    },
    isCenterExecutePage() {
      return generateCurrentRoute() === "center-execute-list";
    },
    isMyCenterExecutePage() {
      return generateCurrentRoute() === "my_center_execute";
    },
    isCenterExecutePlannerPage() {
      return generateCurrentRoute() === "center-execute-planner";
    },
    isEndedCenterExecutePage() {
      return generateCurrentRoute() === "ended_center_execute";
    },
  },
  methods: {
    ...mapActions(["setAction"]),
    pathOr,
    checkPermission,
    listWrapperReload() {
      this.$refs.listWrapper.reload();
    },
    async showBody(item) {
      try {
        const centerExecuteCode = pathOr(null, ["code"], item);
        const response = await getCenterExecute(centerExecuteCode);
        return response;
      } catch (error) {
        generateError(error);
      }
    },
    getPermissions(value) {
      this.permissions = value;
    },
    showItemMenu(item) {
      const id = pathOr(null, ["id"], item);
      this.itemMenuId = this.itemMenuId === id ? null : id;
    },
    closeItemMenu() {
      this.itemMenuId = null;
    },
    goToCenterExecuteEdit(item) {
      const currentRouteName = generateCurrentRoute();
      storeDispatcher("mobileHeaderBaseRoute", currentRouteName);
      const name = this.isCenterExecutePlannerPage
        ? "center-execute-planner-edit"
        : "center-execute-edit";
      const centerExecuteId = pathOr(null, ["id"], item);
      const params = { centerExecuteId };
      goToRoute(name, params, {}, false);
    },
    goToReportDashboard(items) {
      const data = items.map((item) => {
        return {
          code: pathOr(null, ["parvandeh", "code"], item),
          parvandehNumber: pathOr(
            null,
            ["parvandeh", "parvandeh_number"],
            item
          ),
          fullName: pathOr(null, ["parvandeh", "person", "name"], item),
          image: pathOr("", ["parvandeh", "image_address"], item),
          termCaption: pathOr("", ["parvandeh", "term_caption"], item),
        };
      });
      localStorage.setItem("dashboard-parvandeh-codes", JSON.stringify(data));
      goToRoute("report_dashboard", {}, {}, false);
    },
    async getCenterExecutePerson(item) {
      const id = pathOr(null, ["id"], item);
      try {
        this.goToDashboardLoading = true;
        const page = 1;
        const perPage = 50;
        const response = await getAllCenterExecutePerson(id, page, perPage);
        const { items } = response;
        const persons = items.filter((person) => {
          const isCandidate =
            pathOr(null, ["executive_role", "id"], person) === 1;
          const isPresent = pathOr(null, ["is_absent", "id"], person) === 0;
          return isCandidate && isPresent;
        });
        this.goToReportDashboard(persons);
      } catch (error) {
        generateError(error);
      } finally {
        this.goToDashboardLoading = false;
      }
    },
    generateItemButtons(item) {
      const buttons = [
        {
          caption: this.$lang.edit,
          icon: "pencil-outline",
          show: !this.isEndedCenterExecutePage,
          permissions: ["admin", "edit"],
          allowStatus: [1, 2, 3],
          allowUserExecutiveRoles: [3, 6, null],
          loading: false,
          click: this.goToCenterExecuteEdit,
        },
        {
          caption: this.$lang.show,
          icon: "eye-outline",
          show: this.isEndedCenterExecutePage,
          permissions: ["admin", "edit"],
          allowStatus: [4, 5],
          allowUserExecutiveRoles: [3, 6, null],
          loading: false,
          click: this.goToCenterExecuteEdit,
        },
        {
          caption: this.$lang.show,
          icon: "eye-outline",
          show: true,
          permissions: ["view"],
          allowStatus: [1, 2, 3, 4, 5],
          allowUserExecutiveRoles: [3, 6, null],
          loading: false,
          click: this.goToCenterExecuteEdit,
        },
        {
          caption: this.$lang.showCenterExecuteCases,
          icon: "folder-outline",
          show: this.checkSharedAccesses("CASE-SHOW"),
          permissions: ["admin", "edit", "view"],
          allowStatus: [2, 3, 4, 5],
          allowUserExecutiveRoles: [2, 3, 4, 5, null],
          loading: false,
          link: this.generateCenterExecuteCasesRouteLink,
        },
        {
          caption: this.$lang.washupLabel,
          icon: "folder-information-outline",
          show: this.checkSharedAccesses("WASHUP"),
          permissions: ["admin", "edit", "view"],
          allowStatus: this.isEndedCenterExecutePage ? [] : [2, 3, 4, 5],
          allowUserExecutiveRoles: this.isEndedCenterExecutePage
            ? [7, null]
            : [3, 5, 6, 7, null],
          shouldCheckHasWashup: true,
          loading: false,
          click: this.goToWashup,
        },
        {
          caption: this.$lang.executePlan,
          icon: "clipboard-text-clock-outline",
          show: !this.isCenterExecutePlannerPage,
          permissions: ["admin", "edit", "view"],
          loading: false,
          click: this.handleOpenExecutePlanListPin,
        },
        {
          caption: this.$lang.submitDelayTime,
          icon: "clock-alert-outline",
          show: this.checkSharedAccesses("SUBMIT-DELAY-TIME"),
          permissions: ["admin", "edit"],
          allowStatus: [1],
          allowUserExecutiveRoles: [3, null],
          loading: false,
          click: this.handleOpenStartDelayModal,
        },
        {
          caption: this.$lang.changeAssessmentPlan,
          icon: "calendar-blank",
          show: this.checkSharedAccesses("CHANGE-ASSESSMENT-PLAN"),
          permissions: ["admin", "edit"],
          allowStatus: [1],
          allowUserExecutiveRoles: [3, null],
          loading: false,
          click: this.handleOpenChangeAssessmentPlanModal,
        },
        {
          caption: this.$lang.excelExport,
          icon: "file-excel-outline",
          show: this.checkSharedAccesses("EXCEL-EXPORT"),
          permissions: ["admin", "edit"],
          allowStatus: this.isEndedCenterExecutePage ? [] : [5, 6],
          allowUserExecutiveRoles: this.isEndedCenterExecutePage
            ? []
            : [3, null],
          loading: this.exportExcelLoading,
          click: this.handleCenterExecuteExport,
        },
        {
          caption: this.$lang.incompleteCompletion,
          icon: "block-helper",
          show: this.checkSharedAccesses("INCOMPLETE-COMPLETION"),
          permissions: ["admin"],
          allowUserExecutiveRoles: [3, null],
          loading: false,
          click: this.handleOpenIncompleteCompletionModal,
        },
        {
          caption: this.$lang.centerExecuteCopy,
          icon: "content-copy",
          show: this.checkSharedAccesses("COPY"),
          allowUserExecutiveRoles: [null],
          permissions: ["admin", "edit"],
          loading: false,
          click: this.handleOpenDuplicateCenterExecuteModal,
        },
        {
          caption: this.$lang.show_in_dashboard,
          icon: "chart-box-outline",
          show: this.checkSharedAccesses("GO_TO_DASHBOARD"),
          permissions: ["admin", "edit", "view"],
          loading: this.goToDashboardLoading,
          click: this.getCenterExecutePerson,
        },
        {
          caption: this.$lang.remove,
          icon: "trash-can-outline",
          show: this.checkSharedAccesses("REMOVE"),
          permissions: ["admin"],
          allowStatus: [1],
          allowUserExecutiveRoles: [3, null],
          loading: false,
          click: this.handleOpenRemoveCenterExecuteModal,
        },
      ];

      const statusId = pathOr(null, ["status"], item);
      const userExecutiveRoleId = pathOr(null, ["executive_role_id"], item);
      return buttons.filter((button) => {
        let condition = true;

        // check has washup
        const shouldCheckHasWashup = pathOr(
          false,
          ["shouldCheckHasWashup"],
          button
        );
        if (shouldCheckHasWashup) {
          const itemHasWashup = !!pathOr(0, ["has_washup"], item);
          condition = condition && itemHasWashup;
        }

        // check status
        const allowStatus = pathOr([], ["allowStatus"], button);
        if (allowStatus.length) {
          condition = condition && includes(statusId, allowStatus);
        }

        // check user executive role
        const allowUserExecutiveRoles = pathOr(
          [],
          ["allowUserExecutiveRoles"],
          button
        );
        if (allowUserExecutiveRoles.length) {
          condition =
            condition && includes(userExecutiveRoleId, allowUserExecutiveRoles);
        }

        return condition;
      });
    },
    handleOpenExecutePlanListPin(item) {
      this.centerExecuteId = pathOr(null, ["id"], item);
      this.isExecutePlanPin = true;
    },
    handleCloseExecutePlanListPin() {
      this.isExecutePlanPin = false;
    },
    handleOpenStartDelayModal(item) {
      this.currentItem = item;
      this.isStartDelayModal = true;
    },
    handleCloseStartDelayModal() {
      this.isStartDelayModal = false;
    },
    handleOpenChangeAssessmentPlanModal(item) {
      this.currentItem = item;
      this.isChangeAssessmentPlanModal = true;
    },
    handleCloseChangeAssessmentPlanModal() {
      this.isChangeAssessmentPlanModal = false;
    },
    generateCenterExecuteCasesRouteLink(item) {
      const name = "center-execute-cases";
      const centerExecuteId = pathOr(null, ["id"], item);
      const params = { centerExecuteId };
      let link = generateRouteLink(name, params);
      link = link.replace("/v2", "");
      return link;
    },

    handleOpenRemoveCenterExecuteModal(item) {
      this.currentItem = item;
      this.isRemoveCenterExecuteModal = true;
    },
    handleCloseRemoveCenterExecuteModal() {
      this.isRemoveCenterExecuteModal = false;
    },
    async removeCenterExecuteItem() {
      try {
        const centerExecuteId = pathOr(null, ["id"], this.currentItem);
        const response = await deleteCenterExecute(centerExecuteId);
        const { message } = response;
        toastAlert(message);
        this.handleCloseRemoveCenterExecuteModal();
        this.listWrapperReload();
      } catch (error) {
        generateError(error);
      }
    },

    handleOpenDuplicateCenterExecuteModal(item) {
      this.currentItem = item;
      this.isDuplicateCenterExecuteModal = true;
    },
    handleCloseDuplicateCenterExecuteModal() {
      this.isDuplicateCenterExecuteModal = false;
    },
    async duplicateCenterExecuteItem() {
      try {
        const centerExecuteCode = pathOr(null, ["code"], this.currentItem);
        const response = await duplicateCenterExecute(centerExecuteCode);
        const { message } = response;
        toastAlert(message);
        this.handleCloseDuplicateCenterExecuteModal();
        this.listWrapperReload();
      } catch (error) {
        generateError(error);
      }
    },

    async handleCenterExecuteExport(item) {
      try {
        this.exportExcelLoading = true;
        const centerExecuteId = pathOr(null, ["id"], item);
        const response = await setCenterExecuteExport(centerExecuteId);
        const { message } = response;
        toastAlert(message);
      } catch (error) {
        generateError(error);
      } finally {
        this.exportExcelLoading = false;
      }
    },
    handleOpenAddCenterExecutePin() {
      this.isAddCenterExecutePin = true;
    },
    handleCloseAddCenterExecutePin() {
      this.isAddCenterExecutePin = false;
    },
    goToWashup(item) {
      const name = "list-washup";
      const centerExecuteId = pathOr(null, ["id"], item);
      const params = { centerExecuteId };
      goToRoute(name, params, {}, false);
    },
    handleOpenAddPersonByExcelModal() {
      this.isAddPersonByExcelModal = true;
    },
    handleCloseAddPersonByExcelModal() {
      this.isAddPersonByExcelModal = false;
    },
    getFilters(filters) {
      this.listFilters = filters;
    },
    handleOpenChangeGroupStatusModal() {
      this.isChangeGroupStatusModal = true;
    },
    handleCloseChangeGroupStatusModal() {
      this.isChangeGroupStatusModal = false;
    },
    async handleSubmitChangeGroupStatus() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        const centerExecuteStatusId = pathOr(
          null,
          ["centerExecuteStatus", "id"],
          this.form
        );
        const response = await setChangeGroupStatus(
          centerExecuteStatusId,
          this.listFilters
        );
        const { message } = response;
        toastAlert(message);
        this.resetForm();
        this.handleCloseChangeGroupStatusModal();
        this.listWrapperReload();
      } catch (error) {
        generateError(error);
      }
    },
    handleOpenIncompleteCompletionModal(item) {
      this.currentItem = item;
      this.isIncompleteCompletion = true;
    },
    handleCloseIncompleteCompletionModal() {
      this.isIncompleteCompletion = false;
    },
    async handleSubmitIncompleteCompletionModal() {
      try {
        const centerExecuteCode = pathOr(null, ["code"], this.currentItem);

        const response = await setIncompleteCompletion(centerExecuteCode);
        const { message } = response;
        toastAlert(message);
        this.handleCloseIncompleteCompletionModal();
        this.listWrapperReload();
      } catch (error) {
        generateError(error);
      }
    },
    handleChangeSelectedItems(code) {
      const index = this.selectedItems.findIndex((item) => item === code);
      if (index !== -1) {
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(code);
      }
    },
    handleOpenScoreExcelExportModal() {
      this.isScoreExcelExportModal = true;
    },
    handleCloseScoreExcelModal() {
      this.isScoreExcelExportModal = false;
    },
    async handleScoreExcelExport() {
      const extraQueryString = generateQueryStringWithKeysRepeat(
        this.selectedItems,
        "center_execute_code"
      );

      try {
        const response = await getCenterExecuteScoreExcel(extraQueryString);
        const { link, message } = response;
        window.open(link, "_blank");
        toastAlert(message);
        this.handleCloseScoreExcelModal();
        this.selectedItems = [];
      } catch (error) {
        generateError(error);
      }
    },

    handleOpenRebuildAllReportsModal() {
      this.isRebuildAllReportsModal = true;
    },
    handleCloseRebuildAllReportsModal() {
      this.isRebuildAllReportsModal = false;
    },
    async handleRebuildAllReports() {
      try {
        const response = await rebuildAllReports();
        const { message } = response;
        toastAlert(message);
        this.handleCloseRebuildAllReportsModal();
      } catch (error) {
        generateError(error);
      }
    },

    checkSharedAccesses(key) {
      const SHARED_ACCESSES = [
        "ADD-PERSON-CENTER-EXECUTE-BY-EXCEL",
        "CASE-SHOW",
        "WASHUP",
        "SUBMIT-DELAY-TIME",
        "CHANGE-ASSESSMENT-PLAN",
        "EXCEL-EXPORT",
        "COPY",
        "REMOVE",
        "ADD",
        "STATUS-TYPE-1",
        "STATUS-TYPE-2",
        "STATUS-TYPE-3",
        "STATUS-TYPE-4",
        "STATUS-TYPE-5",
        "INCOMPLETE-COMPLETION",
        "GO_TO_DASHBOARD",
      ];
      let allowAccesses = [];

      if (this.isCenterExecutePage || this.isMyCenterExecutePage) {
        allowAccesses = [
          "ADD-PERSON-CENTER-EXECUTE-BY-EXCEL",
          "CASE-SHOW",
          "WASHUP",
          "SUBMIT-DELAY-TIME",
          "CHANGE-ASSESSMENT-PLAN",
          "COPY",
          "REMOVE",
          "ADD",
          "STATUS-TYPE-1",
          "STATUS-TYPE-2",
          "STATUS-TYPE-3",
          "STATUS-TYPE-4",
          "STATUS-TYPE-5",
          "INCOMPLETE-COMPLETION",
        ];
      }
      if (this.isCenterExecutePlannerPage) {
        allowAccesses = ["STATUS-TYPE-1", "STATUS-TYPE-2", "STATUS-TYPE-3"];
      }
      if (this.isEndedCenterExecutePage) {
        allowAccesses = [
          "STATUS-TYPE-3",
          "STATUS-TYPE-4",
          "STATUS-TYPE-5",
          "EXCEL-EXPORT",
          "CASE-SHOW",
          "WASHUP",
          "COPY",
          "GO_TO_DASHBOARD",
        ];
      }

      return includes(key, allowAccesses);
    },
  },
  mounted() {
    const currentRouteName = generateCurrentRoute();
    localStorage.setItem("centerExecuteListBackRoute", currentRouteName);
  },
};
</script>
